/**
 * Product standard hours (normuren). Stored as hours; work orders use minutes.
 * Display uses a Dutch decimal comma (1,5); input also accepts a period (1.5).
 */

export function parseHoursInput(value) {
  if (value == null || value === '') return null;
  const raw = String(value).trim();
  if (!raw) return null;
  const n = Number(raw.replace(',', '.'));
  if (!Number.isFinite(n) || n < 0) return null;
  return Math.round(n * 100) / 100;
}

export function formatHoursInput(value) {
  if (value == null || value === '') return '';
  const n = parseHoursInput(value);
  if (n == null) return String(value).trim();
  return Number.isInteger(n) ? String(n) : String(n).replace('.', ',');
}

export function hoursToMinutes(hours) {
  const n = parseHoursInput(hours);
  if (n == null || n <= 0) return 0;
  return Math.round(n * 60);
}

export function durationMinutesFromProducts(products) {
  const list = Array.isArray(products) ? products : [];
  let total = 0;
  let any = false;
  for (const product of list) {
    const minutes = hoursToMinutes(product?.standardHours ?? product?.standard_hours);
    if (minutes > 0) {
      total += minutes;
      any = true;
    }
  }
  return any ? total : null;
}

export function formatHoursLabel(hours) {
  const text = formatHoursInput(hours);
  const n = parseHoursInput(text);
  if (n == null || n <= 0) return '';
  return `${text} u`;
}

export function formatMinutesAsHoursLabel(minutes) {
  if (!Number.isFinite(minutes) || minutes <= 0) return '';
  return formatHoursLabel(minutes / 60);
}
